import React, { FC } from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import ListItemAvatar from '@mui/material/ListItemAvatar'

import UploadedImage from '../widgets/UploadedImage'

import {
  IRecord_KnowledgeBase,
  IRecord_KnowledgeBase_Page,
} from '@kaidam/fc-shared/src/types/schema/knowledgebase'


interface KnowledgebasePageListProps {
  article: Partial<IRecord_KnowledgeBase>,
  selected?: string,
  getPageAdminButton?: {
    (page: IRecord_KnowledgeBase_Page, i: number): any,
  },
  onSelect: {
    (page: IRecord_KnowledgeBase_Page): void,
  }
}

const KnowledgebasePageList: FC<React.PropsWithChildren<KnowledgebasePageListProps>> = ({
  article,
  selected = '',
  getPageAdminButton,
  onSelect,
}) => {

  return (
    <List>
      {
        article.data.pages.map((page, i) => {
          const screenshot = article.meta?.screenshots && article.meta.screenshots[i] ? article.meta.screenshots[i] : null
          return (
            <ListItem
              key={ page.id }
              selected={ page.id == selected }
              button
              onClick={ () => onSelect(page) }
            >
              {
                screenshot && (
                  <ListItemAvatar>
                    <UploadedImage
                      file={ screenshot }
                      avatar
                    />
                  </ListItemAvatar>
                )
              }
              <ListItemText
                primary={ page.title }
              />
              {
                getPageAdminButton && getPageAdminButton(page, i)
              }
            </ListItem>
          )
        })
      }
    </List>
  )
}

export default KnowledgebasePageList